import {
  Component,
  ComponentInterface,
  h,
  Prop,
} from '@stencil/core';

@Component({
  shadow: true,
  styleUrl: 'paf-result-price-badge.scss',
  tag: 'paf-result-price-badge',
})

export class PafResultPriceBadge implements ComponentInterface {

  /**
   * The text (price) to show
   */
  @Prop() public priceText!: string;

  /**
   * Discount labels get a % sign in front of the text and a special background
   */
  @Prop() public isDiscount?: boolean;

  /**
   * If set to true, the component will show a loading skeleton
   */
  @Prop() public loading?: boolean;

  public render(): HTMLDivElement {
    return (
      <div
        class={{
          'badge': true,
          'is-discount': this.isDiscount,
          'loading': this.loading,
        }}
        data-testid='badge'
      >

        {this.loading &&
          <div class='loader'></div>
        }

        {this.isDiscount &&
          <span class='discount'>%</span>
        }
        <span
          class='text'
          data-testid='text'
        >{this.priceText}</span>
      </div>
    );
  }
}
